import bykApi from '../bykApi';
// 本地缓存
let smPayAdmin = {
  sys: {
    // mainSrvUrl: 'http://sanmipos.com:5837', // 主服务器IP地址
    mainSrvUrl: 'https://sanmipos.com', // 主服务器IP地址
    // mainSrvIp:'www.sanmipos.com',
    ver: '202202140001', // 版本号
    apiVer:'2', //'1'老接口 2新接口
  },
  orgUserInfo: {
    commissionValue:'',
    commissionMethod:'',
    userId: '', //机构登录工号
    userName: '', // 机构登录员工名
    token: '',
    mainToken: '', //20260108使用新接口
    mchAlipayCommissionRate: '',
    mchDebitcardCommissionRate: '',
    mchDebitcardMaxCommissionRate: '',
    mchLdebitcardCommissionRate: '',
    mchSubCommissionRate: '',
    mchUnionpayCommissionRate: '',
    mchWechatCommissionRate: '',
    login_only:'N',
  },
  orgInfo: {
    smpay_name:'',
    call_back_url:'',
    smpay_id:'',
    can_incom_yn:'',
    orgId: '', //机构编码 或 手机号
    compName: '', //机构公司名
    orgAk: '',
    orgSk: '',
    pOrgId: '', //上级机构编码
    alipayCommissionRate: '',
    debitcardCommissionRate: '',
    debitcardMaxCommissionRate: '',
    ldebitcardCommissionRate: '',
    subCommissionRate: '',
    unionpayCommissionRate: '',
    wechatCommissionRate: '',
    userPsw:'',
  },
};


// 修改  缓存信息
const fSetByPayAdmin = (obj) => {
  // 直接使用传入的obj参数更新smPayAdmin对象，避免从localStorage重新读取覆盖修改
  // 用户名
  smPayAdmin.orgUserInfo.userId = obj.orgUserInfo.userId
  //姓名
  smPayAdmin.orgUserInfo.userName = obj.orgUserInfo.userName
  //2026改新token
  smPayAdmin.orgUserInfo.mainToken = obj.orgUserInfo.mainToken
  console.log(obj.orgUserInfo.mainToken,'obj.orgUserInfo.mainToken')
  console.log(smPayAdmin.orgUserInfo.mainToken,'smPayAdmin.orgUserInfo.mainToken')
  // token
  smPayAdmin.orgUserInfo.token = obj.orgUserInfo.token
  smPayAdmin.orgUserInfo.mchAlipayCommissionRate = obj.orgUserInfo.mchAlipayCommissionRate
  smPayAdmin.orgUserInfo.commissionValue =obj.orgUserInfo.commissionValue
  smPayAdmin.orgUserInfo.commissionMethod =obj.orgUserInfo.commissionMethod
  smPayAdmin.orgUserInfo.mchDebitcardCommissionRate = obj.orgUserInfo.mchDebitcardCommissionRate
  smPayAdmin.orgUserInfo.mchDebitcardMaxCommissionRate = obj.orgUserInfo.mchDebitcardMaxCommissionRate
  smPayAdmin.orgUserInfo.mchLdebitcardCommissionRate = obj.orgUserInfo.mchLdebitcardCommissionRate
  smPayAdmin.orgUserInfo.mchSubCommissionRate = obj.orgUserInfo.mchSubCommissionRate
  smPayAdmin.orgUserInfo.mchUnionpayCommissionRate = obj.orgUserInfo.mchUnionpayCommissionRate
  smPayAdmin.orgUserInfo.mchWechatCommissionRate = obj.orgUserInfo.mchWechatCommissionRate
  smPayAdmin.orgUserInfo.login_only = obj.orgUserInfo.login_only


  //修改 缓存机构信息
  smPayAdmin.orgInfo.smpay_name = obj.orgInfo.smpay_name
  smPayAdmin.orgInfo.call_back_url = obj.orgInfo.call_back_url
  smPayAdmin.orgInfo.smpay_id = obj.orgInfo.smpay_id
  smPayAdmin.orgInfo.can_incom_yn = obj.orgInfo.can_incom_yn
  smPayAdmin.orgInfo.orgId = obj.orgInfo.orgId
  smPayAdmin.orgInfo.compName = obj.orgInfo.compName
  smPayAdmin.orgInfo.orgAk = obj.orgInfo.orgAk
  smPayAdmin.orgInfo.orgSk = obj.orgInfo.orgSk
  smPayAdmin.orgInfo.pOrgId = obj.orgInfo.pOrgId
  smPayAdmin.orgInfo.alipayCommissionRate = obj.orgInfo.alipayCommissionRate
  smPayAdmin.orgInfo.debitcardCommissionRate = obj.orgInfo.debitcardCommissionRate
  smPayAdmin.orgInfo.debitcardMaxCommissionRate = obj.orgInfo.debitcardMaxCommissionRate
  smPayAdmin.orgInfo.ldebitcardCommissionRate = obj.orgInfo.ldebitcardCommissionRate
  smPayAdmin.orgInfo.subCommissionRate = obj.orgInfo.subCommissionRate
  smPayAdmin.orgInfo.unionpayCommissionRate = obj.orgInfo.unionpayCommissionRate
  smPayAdmin.orgInfo.wechatCommissionRate = obj.orgInfo.wechatCommissionRate
  smPayAdmin.orgInfo.userPsw = obj.orgInfo.userPsw


  //保存权限
  smPayAdmin.user_auth_info = obj.user_auth_info
  //更新localStorage
  localStorage.setItem('smPayAdmin', JSON.stringify(smPayAdmin))
}

// 获取 缓存信息
const fGetByPayAdmin = () => {
  if (!localStorage.smPayAdmin) {
    localStorage.setItem('smPayAdmin', JSON.stringify(smPayAdmin))

  }
  return JSON.parse(localStorage.smPayAdmin)
}


// 修改 缓存机构信息
//   const fSetByPayAdminOrgInfo = (obj) => {
//     // 取值
//     smPayAdmin = JSON.parse(localStorage.smPayAdmin)
//     // if (!bykApi.smCom.fSmIsEmpty(obj.orgInfo.orgId)) {
//         smPayAdmin.orgInfo.orgId = obj.orgInfo.orgId
//     // }
//     // if (!bykApi.smCom.fSmIsEmpty(obj.orgInfo.compName)) {
//         smPayAdmin.orgInfo.compName = obj.orgInfo.compName
//     // }
//     // if (!bykApi.smCom.fSmIsEmpty(obj.orgInfo.orgAk)) {
//         smPayAdmin.orgInfo.orgAk = obj.orgInfo.orgAk
//     // }
//     // if (!bykApi.smCom.fSmIsEmpty(obj.orgInfo.orgSk)) {
//         smPayAdmin.orgInfo.orgSk = obj.orgInfo.orgSk
//     // }
//     smPayAdmin.orgInfo.pOrgId = obj.orgInfo.pOrgId
//     localStorage.setItem('smPayAdmin', JSON.stringify(smPayAdmin))

// }







const fGetLocalItem = (name) => {
  const data = localStorage.getItem(name)
  // 为什么把 JSON.parse 放到 try-catch 中？
  // 因为 data 可能不是 JSON 格式字符串
  try {
    // 尝试把 data 转为 JavaScript 对象
    return JSON.parse(data)
  } catch (err) {
    // data 不是 JSON 格式字符串，直接原样返回
    return data
  }
}

const fSetLocalItem = (name, value) => {
  // 如果 value 是对象，就把 value 转为 JSON 格式字符串再存储
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  localStorage.setItem(name, value)
}

const fRemoveLocalItem = (name) => {
  window.localStorage.removeItem(name)
}




export default {
  smPayAdmin, //本地缓存对象
  // fSetByPayAdminOrgUserInfo, // 修改 缓存机构用户信息
  // fSetByPayAdminOrgInfo, // 修改 缓存机构信息
  fSetByPayAdmin, // 修改 缓存信息
  fGetByPayAdmin, // 获取 缓存信息
  fGetLocalItem, //获取本地存储
  fSetLocalItem, //设置本地存储
  fRemoveLocalItem, //删除本地存储

}



// WEBPACK FOOTER //
// ./src/common/global/global.js